//@ts-nocheck
import { axiosGroup } from ".";

export const getContentAPI = async (locale: string) => {
  const contents = await axiosGroup.axiosCms.get("/contents?locale=" + locale);

  return contents.data.data[0].data;
};
